module.exports = __webpack_public_path__ + "img/17_73.1562115f.png";